/**
 * @fileoverview This file is generated by the Angular 2 template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties}
 */
/* tslint:disable */
import * as import0 from '../../../app/tone_list/tone-list.component';
import * as import1 from '@angular/core/src/linker/view';
import * as import3 from '@angular/core/src/linker/view_utils';
import * as import4 from '@angular/core/src/metadata/view';
import * as import5 from '@angular/core/src/linker/view_type';
import * as import6 from '@angular/core/src/change_detection/constants';
import * as import7 from '@angular/core/src/linker/component_factory';
import * as import8 from '../../../app/app_bus/app-bus';
import * as import9 from '@angular/router/src/router_state';
import * as import10 from './tone-list.css.shim.ngstyle';
import * as import11 from '@angular/core/src/linker/view_container';
import * as import12 from '../../../node_modules/@angular/common/src/directives/ng_for.ngfactory';
import * as import13 from '@angular/common/src/pipes/async_pipe';
import * as import14 from '../../../app/pipes/time-elapsed.pipe';
import * as import15 from '@angular/core/src/change_detection/change_detection_util';
import * as import16 from '@angular/core/src/linker/template_ref';
import * as import17 from '@angular/core/src/change_detection/differs/iterable_differs';
import * as import18 from '@angular/common/src/directives/ng_for';
import * as import19 from '../../../app/tone_list/tone_entry/tone-entry.component';
import * as import20 from './tone_entry/tone-entry.component.ngfactory';
export class Wrapper_ToneListComponent {
    constructor(p0, p1) {
        this._changed = false;
        this.context = new import0.ToneListComponent(p0, p1);
    }
    ngOnDetach(view, componentView, el) {
    }
    ngOnDestroy() {
    }
    ngDoCheck(view, el, throwOnChange) {
        var changed = this._changed;
        this._changed = false;
        if (!throwOnChange) {
            if ((view.numberOfChecks === 0)) {
                this.context.ngOnInit();
            }
        }
        return changed;
    }
    checkHost(view, componentView, el, throwOnChange) {
    }
    handleEvent(eventName, $event) {
        var result = true;
        return result;
    }
    subscribe(view, _eventHandler) {
        this._eventHandler = _eventHandler;
    }
}
var renderType_ToneListComponent_Host = import3.createRenderComponentType('', 0, import4.ViewEncapsulation.None, [], {});
class View_ToneListComponent_Host0 extends import1.AppView {
    constructor(viewUtils, parentView, parentIndex, parentElement) {
        super(View_ToneListComponent_Host0, renderType_ToneListComponent_Host, import5.ViewType.HOST, viewUtils, parentView, parentIndex, parentElement, import6.ChangeDetectorStatus.CheckAlways);
    }
    createInternal(rootSelector) {
        this._el_0 = import3.selectOrCreateRenderHostElement(this.renderer, 'tone-list-component', import3.EMPTY_INLINE_ARRAY, rootSelector, null);
        this.compView_0 = new View_ToneListComponent0(this.viewUtils, this, 0, this._el_0);
        this._ToneListComponent_0_3 = new Wrapper_ToneListComponent(this.injectorGet(import8.AppBus, this.parentIndex), this.injectorGet(import9.ActivatedRoute, this.parentIndex));
        this.compView_0.create(this._ToneListComponent_0_3.context);
        this.init(this._el_0, (this.renderer.directRenderer ? null : [this._el_0]), null);
        return new import7.ComponentRef_(0, this, this._el_0, this._ToneListComponent_0_3.context);
    }
    injectorGetInternal(token, requestNodeIndex, notFoundResult) {
        if (((token === import0.ToneListComponent) && (0 === requestNodeIndex))) {
            return this._ToneListComponent_0_3.context;
        }
        return notFoundResult;
    }
    detectChangesInternal(throwOnChange) {
        this._ToneListComponent_0_3.ngDoCheck(this, this._el_0, throwOnChange);
        this.compView_0.internalDetectChanges(throwOnChange);
    }
    destroyInternal() {
        this.compView_0.destroy();
    }
    visitRootNodesInternal(cb, ctx) {
        cb(this._el_0, ctx);
    }
}
export const ToneListComponentNgFactory = new import7.ComponentFactory('tone-list-component', View_ToneListComponent_Host0, import0.ToneListComponent);
const styles_ToneListComponent = [import10.styles];
var renderType_ToneListComponent = import3.createRenderComponentType('', 0, import4.ViewEncapsulation.Emulated, styles_ToneListComponent, {});
export class View_ToneListComponent0 extends import1.AppView {
    constructor(viewUtils, parentView, parentIndex, parentElement) {
        super(View_ToneListComponent0, renderType_ToneListComponent, import5.ViewType.COMPONENT, viewUtils, parentView, parentIndex, parentElement, import6.ChangeDetectorStatus.CheckAlways);
        this._expr_55 = import15.UNINITIALIZED;
        this._expr_56 = import15.UNINITIALIZED;
        this._expr_58 = import15.UNINITIALIZED;
        this._expr_59 = import15.UNINITIALIZED;
    }
    createInternal(rootSelector) {
        const parentRenderNode = this.renderer.createViewRoot(this.parentElement);
        this._text_0 = this.renderer.createText(parentRenderNode, '\n', null);
        this._el_1 = import3.createRenderElement(this.renderer, parentRenderNode, 'div', new import3.InlineArray2(2, 'class', 'tone-list'), null);
        this._text_2 = this.renderer.createText(this._el_1, '\n  ', null);
        this._el_3 = import3.createRenderElement(this.renderer, this._el_1, 'div', new import3.InlineArray2(2, 'class', 'list-header'), null);
        this._text_4 = this.renderer.createText(this._el_3, '\n    ', null);
        this._el_5 = import3.createRenderElement(this.renderer, this._el_3, 'div', new import3.InlineArray2(2, 'class', 'play-pause-ctnr'), null);
        this._text_6 = this.renderer.createText(this._el_5, '\n      ', null);
        this._el_7 = import3.createRenderElement(this.renderer, this._el_5, 'button', new import3.InlineArray2(2, 'class', 'play-pause-btn'), null);
        this._text_8 = this.renderer.createText(this._el_7, '\n        ', null);
        this._el_9 = import3.createRenderElement(this.renderer, this._el_7, 'div', new import3.InlineArray2(2, 'class', 'fa fa-play'), null);
        this._text_10 = this.renderer.createText(this._el_7, '\n      ', null);
        this._text_11 = this.renderer.createText(this._el_5, '\n      ', null);
        this._el_12 = import3.createRenderElement(this.renderer, this._el_5, 'button', new import3.InlineArray2(2, 'class', 'play-pause-btn'), null);
        this._text_13 = this.renderer.createText(this._el_12, '\n        ', null);
        this._el_14 = import3.createRenderElement(this.renderer, this._el_12, 'div', new import3.InlineArray2(2, 'class', 'fa fa-pause'), null);
        this._text_15 = this.renderer.createText(this._el_12, '\n      ', null);
        this._text_16 = this.renderer.createText(this._el_5, '\n    ', null);
        this._text_17 = this.renderer.createText(this._el_3, '\n    ', null);
        this._el_18 = import3.createRenderElement(this.renderer, this._el_3, 'div', new import3.InlineArray2(2, 'class', 'time-elapsed-ctnr'), null);
        this._text_19 = this.renderer.createText(this._el_18, '\n      ', null);
        this._el_20 = import3.createRenderElement(this.renderer, this._el_18, 'p', new import3.InlineArray2(2, 'class', 'time'), null);
        this._text_21 = this.renderer.createText(this._el_20, '', null);
        this._text_22 = this.renderer.createText(this._el_18, '\n    ', null);
        this._text_23 = this.renderer.createText(this._el_3, '\n  ', null);
        this._text_24 = this.renderer.createText(this._el_1, '\n  ', null);
        this._el_25 = import3.createRenderElement(this.renderer, this._el_1, 'div', new import3.InlineArray2(2, 'class', 'tone-entry-row'), null);
        this._text_26 = this.renderer.createText(this._el_25, '\n    ', null);
        this._el_27 = import3.createRenderElement(this.renderer, this._el_25, 'div', new import3.InlineArray2(2, 'class', 'delete-ctnr'), null);
        this._text_28 = this.renderer.createText(this._el_25, '\n    ', null);
        this._el_29 = import3.createRenderElement(this.renderer, this._el_25, 'div', new import3.InlineArray2(2, 'class', 'frequency-ctnr'), null);
        this._el_30 = import3.createRenderElement(this.renderer, this._el_29, 'span', import3.EMPTY_INLINE_ARRAY, null);
        this._text_31 = this.renderer.createText(this._el_30, 'Frequency', null);
        this._text_32 = this.renderer.createText(this._el_25, '\n    ', null);
        this._el_33 = import3.createRenderElement(this.renderer, this._el_25, 'div', new import3.InlineArray2(2, 'class', 'delay-ctnr'), null);
        this._el_34 = import3.createRenderElement(this.renderer, this._el_33, 'span', import3.EMPTY_INLINE_ARRAY, null);
        this._text_35 = this.renderer.createText(this._el_34, 'Delay', null);
        this._text_36 = this.renderer.createText(this._el_25, '\n    ', null);
        this._el_37 = import3.createRenderElement(this.renderer, this._el_25, 'div', new import3.InlineArray2(2, 'class', 'duration-ctnr'), null);
        this._el_38 = import3.createRenderElement(this.renderer, this._el_37, 'span', import3.EMPTY_INLINE_ARRAY, null);
        this._text_39 = this.renderer.createText(this._el_38, 'Duration', null);
        this._text_40 = this.renderer.createText(this._el_25, '\n    ', null);
        this._el_41 = import3.createRenderElement(this.renderer, this._el_25, 'div', new import3.InlineArray2(2, 'class', 'volume-ctnr'), null);
        this._el_42 = import3.createRenderElement(this.renderer, this._el_41, 'span', import3.EMPTY_INLINE_ARRAY, null);
        this._text_43 = this.renderer.createText(this._el_42, 'Volume', null);
        this._text_44 = this.renderer.createText(this._el_25, '\n    ', null);
        this._el_45 = import3.createRenderElement(this.renderer, this._el_25, 'div', new import3.InlineArray2(2, 'class', 'pan-ctnr'), null);
        this._el_46 = import3.createRenderElement(this.renderer, this._el_45, 'span', import3.EMPTY_INLINE_ARRAY, null);
        this._text_47 = this.renderer.createText(this._el_46, 'Pan', null);
        this._text_48 = this.renderer.createText(this._el_25, '\n  ', null);
        this._text_49 = this.renderer.createText(this._el_1, '\n  ', null);
        this._anchor_50 = this.renderer.createTemplateAnchor(this._el_1, null);
        this._vc_50 = new import11.ViewContainer(50, 1, this, this._anchor_50);
        this._TemplateRef_50_5 = new import16.TemplateRef_(this, 50, this._anchor_50);
        this._NgFor_50_6 = new import12.Wrapper_NgFor(this._vc_50.vcRef, this._TemplateRef_50_5, this.parentView.injectorGet(import17.IterableDiffers, this.parentIndex), this.ref);
        this._text_51 = this.renderer.createText(this._el_1, '\n', null);
        var disposable_0 = import3.subscribeToRenderElement(this, this._el_7, new import3.InlineArray2(2, 'click', null), this.eventHandler(this.handleEvent_7));
        this._pipe_async_0 = new import13.AsyncPipe(this.ref);
        var disposable_1 = import3.subscribeToRenderElement(this, this._el_12, new import3.InlineArray2(2, 'click', null), this.eventHandler(this.handleEvent_12));
        this._pipe_timeElapsed_1 = new import14.TimeElapsedPipe();
        this._pipe_timeElapsed_1_0 = import3.pureProxy1(this._pipe_timeElapsed_1.transform.bind(this._pipe_timeElapsed_1));
        this.init(null, (this.renderer.directRenderer ? null : [
            this._text_0,
            this._el_1,
            this._text_2,
            this._el_3,
            this._text_4,
            this._el_5,
            this._text_6,
            this._el_7,
            this._text_8,
            this._el_9,
            this._text_10,
            this._text_11,
            this._el_12,
            this._text_13,
            this._el_14,
            this._text_15,
            this._text_16,
            this._text_17,
            this._el_18,
            this._text_19,
            this._el_20,
            this._text_21,
            this._text_22,
            this._text_23,
            this._text_24,
            this._el_25,
            this._text_26,
            this._el_27,
            this._text_28,
            this._el_29,
            this._el_30,
            this._text_31,
            this._text_32,
            this._el_33,
            this._el_34,
            this._text_35,
            this._text_36,
            this._el_37,
            this._el_38,
            this._text_39,
            this._text_40,
            this._el_41,
            this._el_42,
            this._text_43,
            this._text_44,
            this._el_45,
            this._el_46,
            this._text_47,
            this._text_48,
            this._text_49,
            this._anchor_50,
            this._text_51
        ]), [
            disposable_0,
            disposable_1
        ]);
        return null;
    }
    injectorGetInternal(token, requestNodeIndex, notFoundResult) {
        if (((token === import16.TemplateRef) && (50 === requestNodeIndex))) {
            return this._TemplateRef_50_5;
        }
        if (((token === import18.NgFor) && (50 === requestNodeIndex))) {
            return this._NgFor_50_6.context;
        }
        return notFoundResult;
    }
    detectChangesInternal(throwOnChange) {
        const valUnwrapper = new import15.ValueUnwrapper();
        const currVal_50_0_0 = this.context.entries;
        this._NgFor_50_6.check_ngForOf(currVal_50_0_0, throwOnChange, false);
        this._NgFor_50_6.ngDoCheck(this, this._anchor_50, throwOnChange);
        this._vc_50.detectChangesInNestedViews(throwOnChange);
        const currVal_55 = this.context.isPlaying;
        if (import3.checkBinding(throwOnChange, this._expr_55, currVal_55)) {
            this.renderer.setElementProperty(this._el_7, 'hidden', currVal_55);
            this._expr_55 = currVal_55;
        }
        valUnwrapper.reset();
        const currVal_56 = !valUnwrapper.unwrap(this._pipe_async_0.transform(this.context.entriesValid()));
        if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange, this._expr_56, currVal_56))) {
            this.renderer.setElementProperty(this._el_7, 'disabled', currVal_56);
            this._expr_56 = currVal_56;
        }
        const currVal_58 = !this.context.isPlaying;
        if (import3.checkBinding(throwOnChange, this._expr_58, currVal_58)) {
            this.renderer.setElementProperty(this._el_12, 'hidden', currVal_58);
            this._expr_58 = currVal_58;
        }
        valUnwrapper.reset();
        const currVal_59 = import3.inlineInterpolate(1, '', valUnwrapper.unwrap(import3.castByValue(this._pipe_timeElapsed_1_0, this._pipe_timeElapsed_1.transform)(this.context.elapsed)), '');
        if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange, this._expr_59, currVal_59))) {
            this.renderer.setText(this._text_21, currVal_59);
            this._expr_59 = currVal_59;
        }
    }
    destroyInternal() {
        this._vc_50.destroyNestedViews();
        this._pipe_async_0.ngOnDestroy();
    }
    createEmbeddedViewInternal(nodeIndex) {
        if ((nodeIndex == 50)) {
            return new View_ToneListComponent1(this.viewUtils, this, 50, this._anchor_50, this._vc_50);
        }
        return null;
    }
    handleEvent_7(eventName, $event) {
        this.markPathToRootAsCheckOnce();
        var result = true;
        if ((eventName == 'click')) {
            const pd_sub_0 = (this.context.startAll() !== false);
            result = (pd_sub_0 && result);
        }
        return result;
    }
    handleEvent_12(eventName, $event) {
        this.markPathToRootAsCheckOnce();
        var result = true;
        if ((eventName == 'click')) {
            const pd_sub_0 = (this.context.stopAll() !== false);
            result = (pd_sub_0 && result);
        }
        return result;
    }
}
class View_ToneListComponent1 extends import1.AppView {
    constructor(viewUtils, parentView, parentIndex, parentElement, declaredViewContainer) {
        super(View_ToneListComponent1, renderType_ToneListComponent, import5.ViewType.EMBEDDED, viewUtils, parentView, parentIndex, parentElement, import6.ChangeDetectorStatus.CheckAlways, declaredViewContainer);
    }
    createInternal(rootSelector) {
        this._el_0 = import3.createRenderElement(this.renderer, null, 'div', import3.EMPTY_INLINE_ARRAY, null);
        this._text_1 = this.renderer.createText(this._el_0, '\n    ', null);
        this._el_2 = import3.createRenderElement(this.renderer, this._el_0, 'tone-entry-component', import3.EMPTY_INLINE_ARRAY, null);
        this.compView_2 = new import20.View_ToneEntryComponent0(this.viewUtils, this, 2, this._el_2);
        this._ToneEntryComponent_2_3 = new import20.Wrapper_ToneEntryComponent(this.parentView.parentView.injectorGet(import8.AppBus, this.parentView.parentIndex));
        this.compView_2.create(this._ToneEntryComponent_2_3.context);
        this._text_3 = this.renderer.createText(this._el_0, '\n  ', null);
        this.init(this._el_0, (this.renderer.directRenderer ? null : [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3
        ]), null);
        return null;
    }
    injectorGetInternal(token, requestNodeIndex, notFoundResult) {
        if (((token === import19.ToneEntryComponent) && (2 === requestNodeIndex))) {
            return this._ToneEntryComponent_2_3.context;
        }
        return notFoundResult;
    }
    detectChangesInternal(throwOnChange) {
        const currVal_2_0_0 = this.context.$implicit;
        this._ToneEntryComponent_2_3.check_entry(currVal_2_0_0, throwOnChange, false);
        this._ToneEntryComponent_2_3.ngDoCheck(this, this._el_2, throwOnChange);
        this.compView_2.internalDetectChanges(throwOnChange);
    }
    destroyInternal() {
        this.compView_2.destroy();
    }
    visitRootNodesInternal(cb, ctx) {
        cb(this._el_0, ctx);
    }
}
//# sourceMappingURL=tone-list.component.ngfactory.js.map